import OrderProvider from "context/OrderContext";
import useAssertParams from "hooks/useAssertParams";
import { useGetOrderByIdQuery } from "app/api/orders";
import LoadingPage from "pages/loading/LoadingPage";
import { Outlet } from "react-router-dom";
import ErrorPage from "pages/error/ErrorPage";

export type OrderParams = {
  orderId: string;
};

const OrderPage: React.FC = () => {
  const { orderId } = useAssertParams<OrderParams>("orderId");
  const { data: order, isLoading, isError, error } = useGetOrderByIdQuery(orderId);

  if (isLoading) return <LoadingPage />;

  if (isError) return <ErrorPage error={error} />;

  if (!order || !orderId) return <ErrorPage.NotFound />;

  return (
    <OrderProvider order={order}>
      <Outlet />
    </OrderProvider>
  );
};

export default OrderPage;
